import {checkWebviewResponse, createFuncHandler, defaultCall, isAppBuild, isWebApiVersion} from "./helper";
import {WebviewApiError} from "./WebviewApiError";
import {webviewContext} from "./context";
import {webviewAppIds} from "../webview";

export function webviewFlowIdIsSupport(context = webviewContext()) {
  return isWebApiVersion(context, {ios: 16})
    || isAppBuild(context, [
      {appId: webviewAppIds.photolabFree, android: 10377},
      {appId: webviewAppIds.fabe, android: 0},
    ]);
}

async function callFlowIdFunc(funcName, extra, context) {
  if (!webviewFlowIdIsSupport(context)) {
    return WebviewApiError.unsupported(funcName).toWebviewResponse();
  }

  const funcHandler = createFuncHandler(context, funcName);
  const response = defaultCall(context, funcName, {
    func: funcHandler.name,
    web_extra: extra,
  });

  return checkWebviewResponse(
    response || await funcHandler.promise,
    (res) => ({flowId: res.flow_id})
  );
}

export function webviewGetFlowId(extra, context = webviewContext()) {
  return callFlowIdFunc("getFlowId", extra, context);
}

export function webviewGenerateFlowId(extra, context = webviewContext()) {
  return callFlowIdFunc("generateFlowId", extra, context);
}
